import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/services";
import { servicesItemListJsonLd, servicesFaqJsonLd } from "@/pages/services.seo";

import { brand } from "@/config/brand";
const SITE_URL = brand.url;
const OG_IMAGE = `${SITE_URL}/__l5e/assets-v1/aabeccab-688e-44b7-96b1-aaf70d6a2a8d/social-share-cover.png`;
const OG_ALT = "Digitally Baffled LTD — UK Digital Transformation Consultancy";

export const Route = createFileRoute("/services/")({
  head: () => ({
    meta: [
      { title: "Services & How We Work | Digitally Baffled" },
      {
        name: "description",
        content:
          "From websites and PPC & Google Ads to SEO, AEO & GEO and ongoing support — see every service we offer and exactly how we work with small businesses.",
      },
      { property: "og:site_name", content: "Digitally Baffled" },
      { property: "og:title", content: "Services & How We Work — Digitally Baffled" },
      {
        property: "og:description",
        content:
          "From websites and PPC & Google Ads to SEO, AEO & GEO and ongoing support — see every service we offer and exactly how we work with small businesses.",
      },
      { property: "og:url", content: `${SITE_URL}/services` },
      { property: "og:type", content: "website" },
      { property: "og:image", content: OG_IMAGE },
      { property: "og:image:secure_url", content: OG_IMAGE },
      { property: "og:image:type", content: "image/png" },
      { property: "og:image:width", content: "1200" },
      { property: "og:image:height", content: "630" },
      { property: "og:image:alt", content: OG_ALT },
      { property: "og:locale", content: "en_GB" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:site", content: "@digitallybaffld" },
      { name: "twitter:creator", content: "@digitallybaffld" },
      { name: "twitter:title", content: "Services & How We Work — Digitally Baffled" },
      {
        name: "twitter:description",
        content:
          "From websites and PPC & Google Ads to SEO, AEO & GEO and ongoing support — see every service we offer and exactly how we work with small businesses.",
      },
      { name: "twitter:image", content: OG_IMAGE },
      { name: "twitter:image:alt", content: OG_ALT },
    ],
    links: [{ rel: "canonical", href: `${SITE_URL}/services` }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(servicesItemListJsonLd) },
      { type: "application/ld+json", children: JSON.stringify(servicesFaqJsonLd) },
    ],
  }),
  component: Page,
});
